export const PARAMS_NAME = {
    onwRevenue: 'ONW Revenue',
    totalRevenue: 'Total Revenue',
    roi: 'ROI',
    roiPercent: 'ROI %',
    wonPercent: 'WIN %',
    ctr: 'CTR'
};
export const NAN_PARAMS = {
    date: 1,
    hour: 1,
    affid: 1,
    subid: 1,
    country: 1
};



// WEBPACK FOOTER //
// ./src/scenes/PushapiDaily/config.js